// jQuery
jQuery(function ($) {
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav').attr('aria-hidden') === 'true';
    $('.gnav').attr('aria-hidden', !hidden);
  });
  $('.gnav a').on('click', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav').attr('aria-hidden', 'true');
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });
});

// JavaScript